import { useDispatch, useSelector } from "react-redux"
import "./rightClickModalForMessageItemDark.css"
import "./rightClickModalForMessageItemLight.css"
import { useEffect, useRef, useState } from "react";
import {
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton,
    PopoverAnchor,
    Button,
    useDisclosure
} from '@chakra-ui/react'
import axios from "axios";
import { getMessageItem } from "../../../../redux/reducer/getMessageItem/action/action";
import { useNavigate, useSearchParams } from "react-router-dom";
import { editMessage, enabledAll, replyToMessage } from "../../../../redux/reducer/otherMenuOptionsForMessageItems/action/action";
import { getChatInfoByIDAction } from "../../../../redux/reducer/getChatInfoByID/action/action";
import { editMessage_trade, enabledAll_trade, replyToMessage_trade } from "../../../../redux/reducer/trade/action/action";
import { getCurrentSubMessageAction } from "../../../../redux/reducer/getCurrentSubMessage/action/action";
import { useToast } from '@chakra-ui/react'
import sockets from "../../../../socket/socket";
const socket = sockets;

export default function RightClickModalForMessageItem({ isOpenModal, item, setisOpenModal, child }) {
    const getDarkModoe = useSelector(darkModes => darkModes);
    const rightClickModalForMessageItemDarkContRef = useRef(null);
    const [mousePosition, setMousePosition] = useState({ x: null, y: null });
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const chatID = searchParams.get('chatID');
    const thread = searchParams.get('thread_message_id');
    const getChatInfo = useSelector(chatInfi => chatInfi.getChatInfoByIDReducer);
    const toast = useToast()
    const navigate = useNavigate();
    // для обновления сокета
    const [chooseWokers, setChooseWokers] = useState([]);
    const gerChekcedCompany = useSelector((allWorkers) => allWorkers);
    const { isOpen, onToggle, onClose } = useDisclosure()


    const openModal = (e) => {
        rightClickModalForMessageItemDarkContRef.current.style.display = "flex"
        e.stopPropagation()

    }

    // useEffect(() => {

    //     if (isOpenModal == false) {
    //         rightClickModalForMessageItemDarkContRef.current.style.display = "none"
    //     }
    // }, [isOpenModal])

    const handleMouseMove = (e) => {
        setMousePosition({ x: e.clientX, y: e.clientY });
    };

    // useEffect(() => {

    //     if (mousePosition.x > 750) {
    //         rightClickModalForMessageItemDarkContRef.current.style.right = "0"
    //         rightClickModalForMessageItemDarkContRef.current.style.top = "281px"
    //     } else if (mousePosition.x < 750) {
    //         rightClickModalForMessageItemDarkContRef.current.style.bottom = "300px"
    //     }

    //     // console.log(mousePosition.x + "x",mousePosition.y + "y");
    // }, [mousePosition])
    // эта функция предназначена для удаления определенного сообщения

    const closeModal = () => {
        setisOpenModal(!isOpenModal)
    }
    const deleteItem = async (e) => {
        e.stopPropagation()

        try {
            const response = await axios.delete(`/api/items/${item._id}`, {
                data: {
                    id: item.senderInfo._id,
                    child
                }
            });
            axiosGetWorkers("/getCurrendCompanyWorkers/api");

            setisOpenModal(!isOpenModal)

            return response.data; // Возвращаем данные, если это необходимо
        } catch (error) {
            console.error('Error:', error);
            throw error; // Если нужно, можно выбросить ошибку для дальнейшей обработки
        }




    };

    const handleImportentUpdate = async (e) => {
        try {
            e.stopPropagation()
            // console.log(item);
            const response = await axios.put(`/ImportentUpdate/api`, { item: item, child });
            axiosGetWorkers("/getCurrendCompanyWorkers/api");

            setisOpenModal(!isOpenModal)
        } catch (error) {
            console.error(error); // Обработка ошибок
            throw new Error("ошибка при обновлении важное сообщение");
        }
    }


    const handlePinMessage = async (e) => {
        try {
            e.stopPropagation()

            axios({
                method: 'get',
                url: `/getChatInfoByID/api?ID=${chatID}`,

            })
                .then(async function (response) {

                    await axios.put(`/pinMessage/api`, { messageItem: item, chatItem: response.data.data.chatOptions });

                    axiosGetWorkers("/getCurrendCompanyWorkers/api");
                    setisOpenModal(!isOpenModal)
                });

        } catch (error) {
            // console.log(error);
        }
    }



    function findPin() {
        const findPin = getChatInfo?.data?.chatOptions?.pinMessageID.includes(item._id);
        if (findPin) {
            return true
        } else {
            return false
        }
    }

    const handleReplyMessage = (e) => {
        if (!child) {
            dispatch(replyToMessage(item))

        } else {
            dispatch(replyToMessage_trade(item))
        }
        closeModal()
        e.stopPropagation()

    }


    const handleEditMessage = (e) => {
        if (!child) {
            dispatch(editMessage(item))

        } else {
            dispatch(editMessage_trade(item))
        }
        closeModal()
        e.stopPropagation()
    }
    const copyURL = () => {
        // Get the current URL
        const url = window.location.href;

        // Use the Clipboard API to copy the URL
        navigator.clipboard.writeText(url)
            .then(() => {
                toast({
                    position: "top",
                    title: 'Ссылка скопирована',
                    description: "Ссылка скопирована",
                    status: 'info',
                    duration: 1000,
                    isClosable: true,
                })
                closeModal()
            })
            .catch((error) => {
                console.error('Failed to copy URL: ', error);
            });
    };

    // FOR SOCKET
    // useEffect(() => {
    //     function onFooEvent() {
    //         dispatch(getChatInfoByIDAction(`/getChatInfoByID/api?ID=${chatID}`))
    //         if (child == false) {
    //             dispatch(getMessageItem(`/getItemMessages/api?chatID=${chatID}`));
    //         } else {
    //             dispatch(getCurrentSubMessageAction(`/getMessageByID/api?thread=${thread}`))
    //         }
    //     }

    //     if (socket) {
    //         socket.on('updateCreatMessage', onFooEvent);

    //         return () => {
    //             socket.off('updateCreatMessage', onFooEvent);
    //         };
    //     }
    // }, []);

    // получение идентификатора пользователей этого чата
    function axiosGetWorkers(url) {
        axios
            .get(url)
            .then(function (response) {
                // handle success
                setChooseWokers([]);
                if (response.data.data) {
                    const newChooseWokers = response.data.data.map(item => item.workerID);
                    setChooseWokers(prevWorkers => [...prevWorkers, ...newChooseWokers]);
                    const adminWorkerID = gerChekcedCompany?.rootReducer?.users?.adminInfo?.workerID;
                    if (adminWorkerID) {
                        setChooseWokers(prevWorkers => [...prevWorkers, adminWorkerID]);
                    }

                    if (newChooseWokers.length > 0 || adminWorkerID) {
                        socket.emit("updateCreatMessage", [...newChooseWokers, adminWorkerID]);
                    } else {
                        alert("No workers found");
                    }
                }
            })
            .catch(function (error) {
                // handle error
                console.error("Error fetching data:", error);
            });
    }
    return (
        <>
            <Popover isLazy placement="left-end" >
                <PopoverTrigger>
                    <div className="openOtherOptions">
                        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none" >
                            <circle cx="1.8002" cy="1.9999" r="1.6" fill="#8C9092" />
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none" >
                            <circle cx="1.8002" cy="1.9999" r="1.6" fill="#8C9092" />
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none" >
                            <circle cx="1.8002" cy="1.9999" r="1.6" fill="#8C9092" />
                        </svg>
                    </div>
                </PopoverTrigger>
                <PopoverContent className={getDarkModoe.ToggleDarkModeReducer.chekced ? "RightClickdarkPopoover" : "RightClicklightPopoover"} position={"right"}>



                    <PopoverBody >
                        <ul className={getDarkModoe.ToggleDarkModeReducer.chekced ? "rightClickModalForMessageItemDarkCont" : "rightClickModalForMessageItemLightCont"} ref={rightClickModalForMessageItemDarkContRef}>
                            <li onClick={(e) => handleReplyMessage(e)}>
                                <div>
                                    <div className="iconContRightClickModal">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                            <path d="M9.28849 9.23717C9.00536 8.38779 7.92735 8.13331 7.29426 8.7664L6.53033 9.53033C6.23744 9.82322 5.76256 9.82322 5.46967 9.53033C5.17678 9.23744 5.17678 8.76256 5.46967 8.46967L6.2336 7.70574C7.65517 6.28417 10.0758 6.8556 10.7115 8.76283C10.9946 9.61221 12.0726 9.86669 12.7057 9.2336L13.4697 8.46967C13.7626 8.17678 14.2374 8.17678 14.5303 8.46967C14.8232 8.76256 14.8232 9.23744 14.5303 9.53033L13.7664 10.2943C12.3448 11.7158 9.92423 11.1444 9.28849 9.23717Z" fill="#6A7180" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M8.96644 0.25H11.0336C12.4053 0.249995 13.4807 0.249992 14.3451 0.320612C15.2252 0.392522 15.9523 0.541379 16.6104 0.876713C17.6924 1.42798 18.572 2.30762 19.1233 3.38955C19.4586 4.04769 19.6075 4.77479 19.6794 5.65494C19.75 6.51928 19.75 7.59471 19.75 8.96642V11.7232C19.75 11.9797 19.75 12.1358 19.7436 12.2719C19.6033 15.2338 17.2338 17.6033 14.2719 17.7436C14.1358 17.75 13.9639 17.75 13.6788 17.75H13.6504L13.5751 17.7501C12.7079 17.7556 11.8632 18.0264 11.1543 18.5259L11.1051 18.5609L8.49441 20.4257C6.9899 21.5003 5.01288 19.9484 5.69954 18.2317C5.79183 18.001 5.62191 17.75 5.37341 17.75H4.77166C2.27441 17.75 0.25 15.7256 0.25 13.2283L0.25 8.96644C0.249995 7.59472 0.249992 6.51929 0.320612 5.65494C0.392522 4.77479 0.541379 4.04769 0.876713 3.38955C1.42798 2.30762 2.30762 1.42798 3.38955 0.876713C4.04769 0.541379 4.77479 0.392522 5.65494 0.320612C6.51929 0.249992 7.59472 0.249995 8.96644 0.25ZM5.77708 1.81563C4.9897 1.87996 4.48197 2.00359 4.07054 2.21322C3.27085 2.62068 2.62068 3.27085 2.21322 4.07054C2.00359 4.48197 1.87996 4.9897 1.81563 5.77708C1.75058 6.57322 1.75 7.58749 1.75 9V13.2283C1.75 14.8972 3.10284 16.25 4.77166 16.25H5.37341C6.68311 16.25 7.57867 17.5728 7.09226 18.7888C6.96197 19.1145 7.33709 19.409 7.62255 19.2051L10.2333 17.3403L10.2902 17.2997C11.2493 16.6239 12.3922 16.2576 13.5655 16.2501L13.6504 16.25C13.9721 16.25 14.1053 16.2498 14.201 16.2452C16.3902 16.1416 18.1416 14.3902 18.2452 12.201C18.2498 12.105 18.25 11.9871 18.25 11.6988V9C18.25 7.58749 18.2494 6.57322 18.1844 5.77708C18.12 4.9897 17.9964 4.48197 17.7868 4.07054C17.3793 3.27085 16.7291 2.62068 15.9295 2.21322C15.518 2.00359 15.0103 1.87996 14.2229 1.81563C13.4268 1.75058 12.4125 1.75 11 1.75H9C7.58749 1.75 6.57322 1.75058 5.77708 1.81563Z" fill="#6A7180" />
                                        </svg>
                                    </div>
                                    <p>Ответить</p>
                                </div>
                            </li >
                            <li onClick={copyURL}>
                                <div>
                                    <div className="iconContRightClickModal">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
                                            <path d="M6 0.25C2.82436 0.25 0.25 2.82436 0.25 6C0.25 9.17564 2.82436 11.75 6 11.75C6.41421 11.75 6.75 11.4142 6.75 11C6.75 10.5858 6.41421 10.25 6 10.25C3.65279 10.25 1.75 8.34721 1.75 6C1.75 3.65279 3.65279 1.75 6 1.75C6.41421 1.75 6.75 1.41421 6.75 1C6.75 0.585786 6.41421 0.25 6 0.25Z" fill="#6A7180" />
                                            <path d="M14 0.25C13.5858 0.25 13.25 0.585786 13.25 1C13.25 1.41421 13.5858 1.75 14 1.75C16.3472 1.75 18.25 3.65279 18.25 6C18.25 8.34721 16.3472 10.25 14 10.25C13.5858 10.25 13.25 10.5858 13.25 11C13.25 11.4142 13.5858 11.75 14 11.75C17.1756 11.75 19.75 9.17564 19.75 6C19.75 2.82436 17.1756 0.25 14 0.25Z" fill="#6A7180" />
                                            <path d="M6 5.25C5.58579 5.25 5.25 5.58579 5.25 6C5.25 6.41421 5.58579 6.75 6 6.75H14C14.4142 6.75 14.75 6.41421 14.75 6C14.75 5.58579 14.4142 5.25 14 5.25H6Z" fill="#6A7180" />
                                        </svg>
                                    </div>
                                    <p>Скопировать ссылку</p>
                                </div>
                            </li>
                            <li onClick={(e) => handleImportentUpdate(e)}>
                                <div>
                                    <div className="iconContRightClickModal">
                                        {
                                            item.isImportantMessage ?
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M10.7751 2.85007C9.90121 0.160654 6.0964 0.160654 5.22256 2.85007C4.96564 3.64079 4.22878 4.17615 3.39737 4.17615C0.569552 4.17615 -0.606198 7.79473 1.68156 9.45688C2.35418 9.94557 2.63564 10.8118 2.37872 11.6025C1.50487 14.2919 4.58302 16.5283 6.87078 14.8662C7.5434 14.3775 8.45421 14.3775 9.12684 14.8662C11.4146 16.5283 14.4927 14.2919 13.6189 11.6025C13.362 10.8118 13.6434 9.94557 14.3161 9.45688C16.6038 7.79473 15.4281 4.17615 12.6002 4.17615C11.7688 4.17615 11.032 3.64079 10.7751 2.85007Z" fill="#F4E02B" />
                                                </svg>
                                                :
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M16.1645 3.27559C14.8538 -0.758531 9.14656 -0.758531 7.83579 3.27559C7.45041 4.46167 6.34513 5.26471 5.09801 5.26471C0.856281 5.26471 -0.907344 10.6926 2.52429 13.1858C3.53323 13.9188 3.95541 15.2182 3.57003 16.4043C2.25926 20.4384 6.87649 23.793 10.3081 21.2998C11.3171 20.5667 12.6833 20.5667 13.6922 21.2998C17.1238 23.793 21.7411 20.4384 20.4303 16.4043C20.0449 15.2182 20.4671 13.9188 21.476 13.1858C24.9077 10.6926 23.144 5.26471 18.9023 5.26471C17.6552 5.26471 16.5499 4.46167 16.1645 3.27559ZM9.26238 3.73912C10.1241 1.08696 13.8762 1.08696 14.7379 3.73912C15.3241 5.54323 17.0054 6.76471 18.9023 6.76471C21.691 6.76471 22.8504 10.3332 20.5944 11.9723C19.0597 13.0873 18.4175 15.0637 19.0037 16.8678C19.8655 19.52 16.8299 21.7254 14.5739 20.0863C13.0392 18.9713 10.9611 18.9712 9.42644 20.0863C7.17038 21.7254 4.13487 19.52 4.99661 16.8678C5.5828 15.0637 4.94064 13.0873 3.40596 11.9723C1.14991 10.3332 2.30937 6.76471 5.09801 6.76471C6.99497 6.76471 8.67619 5.54323 9.26238 3.73912Z" fill="#6A7180" />
                                                </svg>
                                        }

                                    </div>
                                    <p>Важное</p>
                                </div>
                            </li>

                            {
                                child == false ?
                                    <li onClick={(e) => handlePinMessage(e)}>
                                        <div>
                                            <div className="iconContRightClickModal">

                                                {
                                                    findPin() ?
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                                                            <path d="M7.41473 10.8535L2 16.2682" stroke="#767676" strokeWidth="1.24955" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M3.66797 6.6762L11.3256 14.3338L12.7393 12.9201L12.4126 9.76603L17.0019 5.873L12.1289 1L8.23578 5.58914L5.08168 5.26249L3.66797 6.6762Z" stroke="#767676" strokeWidth="1.24955" strokeLinecap="round" strokeLinejoin="round" />
                                                            <path d="M1 1L19 19" stroke="#767676" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                        :
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22" fill="none">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M7.9098 3.3139C5.42451 3.26895 2.99011 4.42363 1.46706 6.54904C1.2451 6.85879 1.02513 7.23981 0.644514 7.89909L0.617424 7.94602C0.613431 7.95293 0.609416 7.95988 0.605386 7.96684C0.559851 8.04558 0.512575 8.12732 0.476457 8.20703C0.131896 8.96749 0.372503 9.86545 1.05113 10.3518C1.12227 10.4027 1.20408 10.4499 1.28289 10.4953C1.28986 10.4993 1.29681 10.5033 1.30372 10.5073L7.47415 14.0698L3.84915 20.3485C3.64205 20.7072 3.76495 21.1659 4.12367 21.373C4.48239 21.5801 4.94108 21.4572 5.14819 21.0985L8.77319 14.8198L14.9436 18.3823C14.9505 18.3863 14.9575 18.3903 14.9645 18.3944C15.0432 18.4399 15.1249 18.4872 15.2046 18.5233C15.9651 18.8678 16.8631 18.6272 17.3494 17.9486C17.4003 17.8775 17.4475 17.7956 17.4929 17.7168C17.4969 17.7098 17.5009 17.7029 17.5049 17.696L17.532 17.6491C17.9127 16.9898 18.1326 16.6088 18.2899 16.2617C19.3693 13.8795 19.1518 11.1933 17.8695 9.06325L17.9776 8.87596C19.5654 6.12578 18.6231 2.60913 15.873 1.02131C13.1228 -0.566504 9.60612 0.375776 8.01831 3.12596L7.9098 3.3139ZM9.547 3.51982C10.0272 3.63337 10.5021 3.79425 10.9651 4.00405C11.3122 4.16132 11.6932 4.38131 12.3525 4.76196L14.3949 5.94115C15.0542 6.32176 15.4352 6.54172 15.7449 6.76368C16.1577 7.0595 16.5341 7.38993 16.8723 7.74862C17.7624 5.78183 17.0319 3.42247 15.123 2.32035C13.2139 1.21817 10.8052 1.76537 9.547 3.51982ZM8.27027 4.83275C6.13288 4.66048 3.99316 5.59908 2.68633 7.42276C2.51289 7.66479 2.33168 7.97684 1.91646 8.69602C1.88617 8.74848 1.86816 8.77972 1.85496 8.80353C1.84656 8.81867 1.84233 8.82703 1.84233 8.82703C1.79387 8.93516 1.82799 9.06248 1.92402 9.13189C1.92402 9.13189 1.93187 9.13701 1.9467 9.14592C1.97004 9.15993 2.00126 9.17799 2.05372 9.20828L8.87367 13.1458L15.6936 17.0833C15.7461 17.1136 15.7773 17.1316 15.8011 17.1448C15.8153 17.1526 15.8221 17.1561 15.8243 17.1572C15.9329 17.2064 16.0606 17.1718 16.1301 17.0749C16.1276 17.0784 16.1302 17.0752 16.1435 17.053C16.1575 17.0297 16.1756 16.9985 16.2059 16.946C16.6211 16.2268 16.8007 15.9139 16.9236 15.6427C17.8511 13.5956 17.5917 11.2689 16.3685 9.50286C15.9697 8.92709 15.4682 8.41077 14.8712 7.98295C14.6292 7.80952 14.3171 7.62831 13.5979 7.21309L11.6494 6.08809C10.9302 5.67287 10.6173 5.49323 10.346 5.37035C9.67357 5.06565 8.97193 4.8893 8.27027 4.83275Z" fill="#6A7180" />
                                                        </svg>
                                                }
                                            </div>
                                            <p>
                                                {
                                                    findPin() ?
                                                        "Открепить "
                                                        :
                                                        "Закрепить"
                                                }

                                            </p>
                                        </div>
                                    </li>
                                    :
                                    ""
                            }
                            <li onClick={(e) => handleEditMessage(e)}>
                                <div>
                                    <div className="iconContRightClickModal">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M15.7276 0.25C15.0835 0.25 14.5514 0.519499 14.0478 0.903733C13.5707 1.26776 13.0409 1.79756 12.4056 2.4329L6.92473 7.91374C6.50384 8.33393 6.17105 8.66617 5.96696 9.09083C5.76286 9.51548 5.71131 9.98289 5.64612 10.574L5.62843 10.7338C5.50649 11.831 5.40597 12.7353 5.42898 13.4477C5.45304 14.1928 5.61405 14.8752 6.14744 15.4086C6.68084 15.942 7.36328 16.103 8.10833 16.1271C8.82071 16.1501 9.72506 16.0496 10.8222 15.9276L10.9821 15.9099C11.5732 15.8447 12.0406 15.7932 12.4652 15.5891C12.8899 15.385 13.2221 15.0522 13.6423 14.6313L19.1231 9.15043C19.7585 8.51512 20.2883 7.98536 20.6523 7.50824C21.0366 7.00463 21.3061 6.47256 21.3061 5.82843C21.3061 5.1843 21.0366 4.65222 20.6523 4.14862C20.2883 3.6715 19.7585 3.14174 19.1232 2.50644L19.0497 2.43293C18.4143 1.79757 17.8846 1.26777 17.4074 0.903733C16.9038 0.519499 16.3718 0.25 15.7276 0.25ZM18.5548 7.59491L13.9611 3.00128C14.3668 2.60162 14.6805 2.30772 14.9577 2.09627C15.3279 1.81383 15.5433 1.75 15.7276 1.75C15.9119 1.75 16.1274 1.81383 16.4976 2.09627C16.8851 2.3919 17.3441 2.84867 18.0257 3.53033C18.7074 4.21199 19.1642 4.67101 19.4598 5.05849C19.7422 5.42866 19.8061 5.64413 19.8061 5.82843C19.8061 6.01272 19.7422 6.22819 19.4598 6.59836C19.2483 6.87551 18.9544 7.18927 18.5548 7.59491ZM12.8992 4.06066L17.4954 8.65685L12.6539 13.4983C12.1265 14.0258 11.9807 14.1577 11.8155 14.2372C11.6502 14.3166 11.4561 14.348 10.7147 14.4303C9.54475 14.5603 8.74843 14.647 8.15674 14.6279C7.58517 14.6094 7.35441 14.4943 7.2081 14.348C7.06179 14.2016 6.94665 13.9709 6.9282 13.3993C6.90909 12.8076 6.99571 12.0113 7.12571 10.8413C7.20808 10.1 7.23947 9.90589 7.31891 9.74061C7.39835 9.57533 7.53029 9.42957 8.05773 8.90213L12.8992 4.06066Z" fill="#6A7180" />
                                            <path d="M8.00899 2.92846C8.42317 2.9235 8.75491 2.58371 8.74995 2.16953C8.74498 1.75534 8.40519 1.42361 7.99101 1.42857C5.56449 1.45766 3.89894 1.59043 2.62024 2.51946C2.13209 2.87412 1.70281 3.3034 1.34815 3.79155C0.762324 4.59787 0.500006 5.54225 0.373728 6.70779C0.249985 7.84992 0.249992 9.28953 0.25 11.1261V11.2166C0.249992 13.0531 0.249985 14.4927 0.373728 15.6348C0.500006 16.8004 0.762324 17.7448 1.34815 18.5511C1.70281 19.0392 2.13209 19.4685 2.62024 19.8232C3.42656 20.409 4.37094 20.6713 5.53648 20.7976C6.67859 20.9213 8.11817 20.9213 9.95465 20.9213H10.0453C11.8818 20.9213 13.3214 20.9213 14.4635 20.7976C15.6291 20.6713 16.5734 20.409 17.3798 19.8232C17.8679 19.4685 18.2972 19.0392 18.6518 18.5511C19.5809 17.2724 19.7137 15.6068 19.7427 13.1803C19.7477 12.7661 19.416 12.4263 19.0018 12.4214C18.5876 12.4164 18.2478 12.7481 18.2428 13.1623C18.2129 15.6631 18.0445 16.835 17.4383 17.6694C17.1762 18.0302 16.8589 18.3475 16.4981 18.6096C15.9901 18.9787 15.3399 19.1939 14.302 19.3063C13.25 19.4203 11.8916 19.4213 10 19.4213C8.10843 19.4213 6.74999 19.4203 5.69804 19.3063C4.66013 19.1939 4.00992 18.9787 3.50191 18.6096C3.14111 18.3475 2.82382 18.0302 2.56168 17.6694C2.19259 17.1614 1.97745 16.5112 1.865 15.4733C1.75103 14.4213 1.75 13.0629 1.75 11.1713C1.75 9.27974 1.75103 7.9213 1.865 6.86936C1.97745 5.83144 2.19259 5.18123 2.56168 4.67322C2.82382 4.31242 3.14111 3.99513 3.50191 3.73299C4.33627 3.1268 5.50819 2.95844 8.00899 2.92846Z" fill="#6A7180" />
                                        </svg>
                                    </div>
                                    <p>Редактировать</p>
                                </div>
                            </li>
                            <li onClick={() => navigate("/task")}>
                                <div>
                                    <div className="iconContRightClickModal">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                            <path d="M9.75 1C9.75 0.585786 9.41421 0.25 9 0.25C8.58579 0.25 8.25 0.585786 8.25 1L8.25 8.25H1C0.585786 8.25 0.25 8.58579 0.25 9C0.25 9.41421 0.585786 9.75 1 9.75H8.25V17C8.25 17.4142 8.58579 17.75 9 17.75C9.41421 17.75 9.75 17.4142 9.75 17V9.75H17C17.4142 9.75 17.75 9.41421 17.75 9C17.75 8.58579 17.4142 8.25 17 8.25H9.75L9.75 1Z" fill="#6A7180" />
                                        </svg>
                                    </div>
                                    <p>Создание задачи</p>
                                </div>
                            </li>
                            <li onClick={(e) => deleteItem(e)}>
                                <div>
                                    <div className="iconContRightClickModal">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M9 0.25C6.37665 0.25 4.25 2.37665 4.25 5V5.25H1C0.585786 5.25 0.25 5.58579 0.25 6C0.25 6.41421 0.585786 6.75 1 6.75H17C17.4142 6.75 17.75 6.41421 17.75 6C17.75 5.58579 17.4142 5.25 17 5.25H13.75V5C13.75 2.37665 11.6234 0.25 9 0.25ZM9 1.75C10.7949 1.75 12.25 3.20507 12.25 5V5.25H5.75V5C5.75 3.20507 7.20507 1.75 9 1.75Z" fill="#6A7180" />
                                            <path d="M2.74664 7.92906C2.70746 7.5167 2.34142 7.21418 1.92906 7.25336C1.5167 7.29254 1.21418 7.65858 1.25336 8.07094C1.34783 9.06522 1.51833 10.2903 1.73748 11.8651L2.01903 13.8881C2.28819 15.8229 2.44085 16.9201 2.77109 17.819C3.3857 19.4918 4.48205 20.8328 5.89206 21.4278C6.65773 21.7509 7.53352 21.7506 8.83733 21.75H9.16267C10.4665 21.7506 11.3423 21.7509 12.1079 21.4278C13.5179 20.8328 14.6143 19.4918 15.2289 17.819C15.5592 16.9201 15.7118 15.8229 15.981 13.8881L16.2625 11.8651C16.4817 10.2903 16.6522 9.06522 16.7466 8.07094C16.7858 7.65858 16.4833 7.29254 16.0709 7.25336C15.6586 7.21418 15.2925 7.5167 15.2534 7.92906C15.1623 8.88702 14.9965 10.08 14.7744 11.6761L14.512 13.5611C14.2215 15.6488 14.0884 16.5736 13.8209 17.3017C13.305 18.7058 12.4472 19.6566 11.5248 20.0458C11.0746 20.2358 10.5292 20.25 9 20.25C7.47083 20.25 6.92544 20.2358 6.47524 20.0458C5.55279 19.6566 4.69496 18.7058 4.17907 17.3017C3.91156 16.5736 3.77851 15.6488 3.48798 13.5611L3.22564 11.6761C3.00352 10.08 2.83766 8.88703 2.74664 7.92906Z" fill="#6A7180" />
                                        </svg>
                                    </div>
                                    <p>Удалить</p>
                                </div>
                            </li>

                        </ul>
                    </PopoverBody>
                </PopoverContent>
            </Popover>
            {/* <div className="openOtherOptions" onClick={(e) => openModal(e)} onMouseMove={handleMouseMove}>
                <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none" onClick={openModal} onMouseMove={handleMouseMove}>
                    <circle cx="1.8002" cy="1.9999" r="1.6" fill="#8C9092" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none" onClick={openModal} onMouseMove={handleMouseMove}>
                    <circle cx="1.8002" cy="1.9999" r="1.6" fill="#8C9092" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none" onClick={openModal} onMouseMove={handleMouseMove}>
                    <circle cx="1.8002" cy="1.9999" r="1.6" fill="#8C9092" />
                </svg>
            </div> */}

        </>
    )
}